import { render, staticRenderFns } from "./Pixel.vue?vue&type=template&id=3e4f71f6&scoped=true"
import script from "./Pixel.vue?vue&type=script&lang=js"
export * from "./Pixel.vue?vue&type=script&lang=js"
import style0 from "./Pixel.vue?vue&type=style&index=0&id=3e4f71f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4f71f6",
  null
  
)

export default component.exports